import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";
import { roundValue, safeParseFloat } from "lib/number";

export const AVERAGE_COST = ({ factoryOptions, getterParams }) => {
    // Get plan row units
    const unitsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.UNITS } };
    const unitsPlanRows = SIMPLE_SUM({ factoryOptions: unitsFactoryOptions, getterParams });

    // Get plan row cost
    const costFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.TOTAL_COST } };
    const costPlanRows = SIMPLE_SUM({ factoryOptions: costFactoryOptions, getterParams });

    const averageCost = safeParseFloat(costPlanRows / unitsPlanRows, 0);
    return roundValue(averageCost, 1);
};
